export default "__VITE_ASSET__2a164e77__"